import { useMemo } from 'react';

import { maskPhoneNumber } from './helpers';
import style from './phone-contact-row.module.less';

type SellerPhoneContactReadonlyDisplayProps = {
  sellerPhoneNumber: string;
};

export const SellerPhoneContactReadonlyDisplay = ({ sellerPhoneNumber }: SellerPhoneContactReadonlyDisplayProps) => {
  const maskedPhoneNumber = useMemo(() => (sellerPhoneNumber ? maskPhoneNumber(sellerPhoneNumber) : ''), [sellerPhoneNumber]);

  return <div className={style['readonly-input-box']}>{maskedPhoneNumber}</div>;
};
